export default function NidraMark({ className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute select-none overflow-hidden ${className}`}
    >
      <span
        className="block font-hindi leading-none"
        style={{
          fontSize: "min(32vw, 320px)",
          color: "#F7DEE4",
          textShadow:
            "2px 2px 0 rgba(255,255,255,0.85), -2px -2px 0 rgba(214,160,172,0.22)",
        }}
      >
        निद्रा
      </span>
    </div>
  );
}
